import { Component, effect, HostBinding, inject, OnDestroy, signal } from '@angular/core';
import { PAGES } from '@constants/constants';
import { LayoutComponent } from '@layout/layout.component';
import { AbbCommonModule } from 'app/abb-common.module';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { ASSET_MANAGEMENT_SUBTITLE } from './asset-management';

@Component({
  selector: 'abb-asset-management',
  standalone: true,
  template: `
    <page-layout
      [page]="PAGES.ASSETMANAGEMENT"
      [title]="'Asset Management' | t"
      (tabchange)="tabChange($event)"
    >
      <span subtitle [innerHTML]="subtitle().key | t : subtitle().params"></span>
    </page-layout>
  `,
  styles: ``,
  imports: [LayoutComponent, AbbCommonModule, TPipe],
  host: { class: 'flex-1' },
  providers: [{ provide: TRANSLATION_PREFIX, useValue: 'asset_management' }],
})
export class AssetManagementComponent {
  @HostBinding('attr.id') componentid = 'asset-management-component';
  readonly PAGES: PAGES = PAGES;
  tab = signal<string>('');
  subtitle = inject(ASSET_MANAGEMENT_SUBTITLE);

  constructor() {}

  tabChange(tab: string) {
    this.tab.set(tab);
  }
}
